import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Table, Button, Row, Col, Tooltip, Space } from 'antd';
import { PlusOutlined, FileExcelOutlined } from '@ant-design/icons';
import { DatePopupconfirm } from '../../../components/datePopupConfirm';
import ProductBundleListTable from './productBundleList';
import dayjs from 'dayjs';
import { LICENSE_TYPES } from '../constants';

export default function ProductList({ products, onEdit, markInactive, onAdd, loading }) {
  const columns = [
    {
      title: 'Product',
      dataIndex: 'product',
      key: 'product',
    },
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'SKU', dataIndex: 'sku', key: 'sku' },
    { title: 'Description', dataIndex: 'description', key: 'description' },
    { title: 'Version', dataIndex: 'version', key: 'version' },
    {
      title: 'Original Price',
      dataIndex: 'price',
      key: 'price',
      render: (value) => (typeof value === 'number' ? value.toFixed(2): value),
    },
    // { title: 'TaxCode', dataIndex: 'tax_code', key: 'tax_code' },
    {
      title: 'License Type',
      dataIndex: 'license_type',
      key: 'license_type',
      render: (value) => {
        const match = LICENSE_TYPES.find((v) => +v.value === +value)
        return match ? match.label : null;
      }
    },
    {
      title: 'Bundle',
      dataIndex: 'is_bundled',
      key: 'is_bundled',
      render: (value) => (value ? 'Yes' : 'No'),
    },
    {
      title: 'Taxable?',
      dataIndex: 'is_taxable',
      key: 'is_taxable',
      render: (value) => (value ? 'Yes' : 'No'),
    },
    {
      title: 'Credit Memo?',
      dataIndex: 'is_credit_memo',
      key: 'is_credit_memo',
      render: (value) => (value ? 'Yes' : 'No'),
    },
    {
      title: 'Actions', key: 'actions',
      render: (_, record) => (
        <Space gap="small" wrap>
          <Button onClick={() => onEdit(record)}>Edit</Button>
          <Tooltip placement='left' title={ !record.is_active ? `Deactivation Effective Date: ${dayjs(record.last_deactivation_date).format('MM/DD/YYYY')}` : '' }>
            <span>
              <DatePopupconfirm
                onConfirm={markInactive}
                customerId={null}
                record_id={record.id}
                is_active={record.is_active}
              />
            </span>
          </Tooltip>
        </Space>
      )
    }
  ];

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  return (
    <>
      <Row justify="end" gutter={8}>
        <Col>
          <Button type="primary" onClick={onAdd} icon={<PlusOutlined />} className='mb-16'>
            ADD PRODUCTS
          </Button>
        </Col>
        {/* <Col>
          <Link to="/products/import">
            <Button type="primary" icon={<FileExcelOutlined />} className='mb-16'>
              IMPORT PRODUCTS
            </Button>
          </Link>
        </Col> */}
      </Row>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={products}
        loading={loading}
        size="small"
        scroll={{ x: 'max-content' }}
        expandable={{
          expandedRowRender: (record) => {
            return (
              <ProductBundleListTable items={record.bundles} />
            )
          },
          expandRowByClick: true,
          expandedRowKeys,
          onExpand: (expanded, record) => {
            setExpandedRowKeys(expanded ? [record.id] : [])
          },
          rowExpandable: (record) => {
            return record?.bundles?.length > 0
          },
        }}
        pagination={false}
      />
    </>
  );
}
